"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardMainContent = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var model_1 = require("../../../model");
var dragAndDrop_1 = require("../../dragAndDrop");
var layout_1 = require("../../layout");
var DateFilterConfigWarnings_1 = require("./DateFilterConfigWarnings");
exports.DashboardMainContent = react_1.forwardRef(function DashboardMainContent(_, ref) {
    var onFiltersChange = model_1.useDispatchDashboardCommand(model_1.changeFilterContextSelection);
    var deselectWidgets = model_1.useWidgetSelection().deselectWidgets;
    var handleDragHoverEnd = dragAndDrop_1.useWidgetDragHoverHandlers().handleDragHoverEnd;
    var _a = tslib_1.__read(dragAndDrop_1.useDashboardDrop(["insight", "insight-placeholder", "insightListItem", "kpi", "kpi-placeholder"], {}), 2), isOver = _a[0].isOver, dropRef = _a[1];
    react_1.useEffect(function () {
        if (!isOver) {
            handleDragHoverEnd();
        }
    }, [handleDragHoverEnd, isOver]);
    return (react_1.default.createElement("div", { className: "gd-flex-item-stretch dash-section dash-section-kpis", ref: ref },
        react_1.default.createElement("div", { className: "gd-flex-container root-flex-maincontent", ref: dropRef, onClick: deselectWidgets },
            react_1.default.createElement(DateFilterConfigWarnings_1.DateFilterConfigWarnings, null),
            react_1.default.createElement(layout_1.DashboardLayout, { onFiltersChange: onFiltersChange }))));
});
//# sourceMappingURL=DashboardMainContent.js.map